export const config = {
    baseUrl : 'http://localhost:3000/',
    apiUrl: 'http://15.222.253.226/api/v1/',
    // apiUrl: 'http://3.21.233.226:4200/api/v1/',
    // apiUrl: 'http://c27c72db4e94.ngrok.io/api/v1/',
    mobile_masking: {format : "##########" , mask :"_" },
    pageLimit: 1000,
}
